import { Grid, Button, Typography, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const PassengersPicker = ({ passengerState, passengerQuantity }) => {
  const theme = useTheme();

  const sendPassengerAction = action => {
    passengerQuantity(action);
  };

  return (
    <Grid
      sx={{
        marginBottom: '10px',
        marginRight: '17px',
      }}
    >
      <Grid
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: { xs: '110px', sm: '120px' },
          height: '42px',
          borderRadius: '5px',
          backgroundColor: '#fff',
          boxShadow: '-1px 1px 6px rgba(0,0,0,0.32)',
        }}
      >
        <Button
          disableRipple
          onClick={() => sendPassengerAction(0)}
          sx={{
            width: '40px',
            height: '100%',
            minWidth: '40px',
            color: '#000',
            borderRadius: '2px 0 0 2px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '&:hover': {
              color: theme.text1,
              bgcolor: theme.primary,
            },
          }}
        >
          <RemoveIcon fontSize="small" />
        </Button>

        <Typography
          sx={{
            fontWeight: 600,
            fontSize: '16px',
            flex: 1,
            textAlign: 'center',
          }}
        >
          {passengerState}
        </Typography>

        <Button
          disableRipple
          onClick={() => sendPassengerAction(1)}
          sx={{
            width: '40px',
            height: '100%',
            minWidth: '40px',
            color: '#000',
            borderRadius: '0 2px 2px 0',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '&:hover': {
              color: theme.text1,
              bgcolor: theme.primary,
            },
          }}
        >
          <AddIcon fontSize="small" />
        </Button>
      </Grid>
    </Grid>
  );
};

export default PassengersPicker;
